import { render, staticRenderFns } from "./initialize.vue?vue&type=template&id=5d22e8c2&scoped=true&"
import script from "./initialize.vue?vue&type=script&lang=js&"
export * from "./initialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22e8c2",
  null
  
)

export default component.exports